import { render, staticRenderFns } from "./WallpaperDetail.vue?vue&type=template&id=c444ef4a&scoped=true&"
import script from "./WallpaperDetail.vue?vue&type=script&lang=js&"
export * from "./WallpaperDetail.vue?vue&type=script&lang=js&"
import style0 from "./WallpaperDetail.vue?vue&type=style&index=0&id=c444ef4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c444ef4a",
  null
  
)

export default component.exports